/**
 * 🇸🇦 المدن السعودية وأحيائها (الأكبر والأشهر)
 *    تُستخدم في الفورمات بدل التعبئة اليدوية
 */

export interface CityData {
  name: string;
  nameEn: string;
  region: string;
  districts: string[];
}

export const SAUDI_CITIES: CityData[] = [
  {
    name: 'الرياض', nameEn: 'Riyadh', region: 'الرياض',
    districts: [
      'العليا', 'الملقا', 'النخيل', 'الياسمين', 'الورود', 'النرجس', 'الربيع', 'الفلاح',
      'حطين', 'الصحافة', 'الياسر', 'القيروان', 'العارض', 'العقيق', 'الواحة', 'الروضة',
      'الربوة', 'النسيم', 'النفل', 'البديعة', 'الشفا', 'السويدي', 'الحمراء', 'المروج',
      'المرقب', 'الدرعية', 'العزيزية', 'المعذر', 'الملز', 'الناصرية', 'المركز التاريخي',
      'الخالدية', 'النموذجية', 'الفيحاء', 'القدس', 'الازدهار', 'الندى', 'الراحة',
      'العمل', 'البطحاء', 'الضباط', 'الرفيعة', 'الفوطة', 'المرسلات', 'الجزيرة',
    ],
  },
  {
    name: 'جدة', nameEn: 'Jeddah', region: 'مكة المكرمة',
    districts: [
      'الزهراء', 'الروضة', 'النعيم', 'البساتين', 'الشاطئ', 'الكورنيش', 'الصفا', 'المروة',
      'البلد', 'النزلة اليمانية', 'النزلة الشرقية', 'الفيصلية', 'العزيزية', 'الحمراء',
      'الأندلس', 'الرحمانية', 'الورود', 'النخيل', 'بحرة', 'أبحر الجنوبية', 'أبحر الشمالية',
      'البوادي', 'السلامة', 'الفيحاء', 'الثغر', 'الجامعة', 'الخالدية', 'المنتزهات',
    ],
  },
  {
    name: 'مكة المكرمة', nameEn: 'Makkah', region: 'مكة المكرمة',
    districts: [
      'العزيزية', 'الششة', 'الزاهر', 'الرصيفة', 'النسيم', 'العتيبية', 'الحجلة',
      'الكعكية', 'الزهراء', 'الجامعة', 'العوالي', 'بطحاء قريش', 'المعابدة',
      'النوارية', 'العدل', 'الشرائع', 'الجموم', 'الحرم', 'الهنداوية', 'العسيلة',
    ],
  },
  {
    name: 'المدينة المنورة', nameEn: 'Madinah', region: 'المدينة المنورة',
    districts: [
      'قباء', 'العنبرية', 'العوالي', 'الحرم', 'سلطانة', 'بني خدرة', 'العاقول', 'الحرة الشرقية',
      'الحرة الغربية', 'الجصة', 'العزيزية', 'الراية', 'الزهراء', 'النخاولة', 'الصالحية',
      'العصيبة', 'الأزهري', 'الخاتم', 'بني معاوية',
    ],
  },
  {
    name: 'الدمام', nameEn: 'Dammam', region: 'الشرقية',
    districts: [
      'الكورنيش', 'الفيصلية', 'البديع', 'الجلوية', 'الإحساء', 'الراكة', 'الفردوس',
      'الخالدية', 'الأمانة', 'الندى', 'الشاطئ', 'النور', 'الجامعيين', 'الإسكان',
      'العنود', 'الزهور', 'الواحة', 'النسيم', 'النخيل', 'الأمل',
    ],
  },
  {
    name: 'الخبر', nameEn: 'Khobar', region: 'الشرقية',
    districts: [
      'الكورنيش', 'البندرية', 'العقربية', 'الراكة', 'الثقبة', 'العزيزية', 'الحمراء',
      'البحيرة', 'الخزامى', 'البندرية', 'الصواري', 'الأندلس', 'الكوثر', 'الجوهرة',
      'الدوحة', 'العقيق', 'الرحاب',
    ],
  },
  {
    name: 'الظهران', nameEn: 'Dhahran', region: 'الشرقية',
    districts: ['الدوحة', 'الجامعة', 'الحي الجامعي', 'الراكة', 'الصواري', 'الأندلس', 'العنود'],
  },
  {
    name: 'الجبيل', nameEn: 'Jubail', region: 'الشرقية',
    districts: ['الجبيل الصناعية', 'الجبيل البلد', 'الفناتير', 'العالية', 'الكورنيش', 'النادي البحري'],
  },
  {
    name: 'الأحساء', nameEn: 'Al-Ahsa', region: 'الشرقية',
    districts: ['الهفوف', 'المبرز', 'البطالية', 'العيون', 'الجفر', 'الكلابية', 'العمران'],
  },
  {
    name: 'القطيف', nameEn: 'Qatif', region: 'الشرقية',
    districts: ['تاروت', 'سيهات', 'صفوى', 'العوامية', 'الجارودية', 'القديح'],
  },
  {
    name: 'الطائف', nameEn: 'Taif', region: 'مكة المكرمة',
    districts: ['الشهداء', 'الفيصلية', 'الهدا', 'شهار', 'الوشحاء', 'الحوية', 'القمرية', 'الشفا'],
  },
  {
    name: 'تبوك', nameEn: 'Tabuk', region: 'تبوك',
    districts: ['الفيصلية', 'الورود', 'الأخضر', 'الروضة', 'المروج', 'العليا', 'الصالحية', 'النزهة'],
  },
  {
    name: 'بريدة', nameEn: 'Buraidah', region: 'القصيم',
    districts: ['الصفراء', 'الصحانة', 'الإسكان', 'النفل', 'الريان', 'الخليج', 'الرابية', 'النخيل'],
  },
  {
    name: 'عنيزة', nameEn: 'Unaizah', region: 'القصيم',
    districts: ['الجوهرة', 'الإسكان', 'القاع', 'النصب', 'العلية', 'الجامعة'],
  },
  {
    name: 'حائل', nameEn: 'Hail', region: 'حائل',
    districts: ['البرزان', 'الجامعة', 'النقرة', 'الجوهرة', 'القلعة', 'الزبارة'],
  },
  {
    name: 'أبها', nameEn: 'Abha', region: 'عسير',
    districts: ['المفتاحة', 'حي الأمير سلطان', 'الموظفين', 'الخالدية', 'العزيزية', 'الورود', 'الشفا'],
  },
  {
    name: 'خميس مشيط', nameEn: 'Khamis Mushait', region: 'عسير',
    districts: ['الجوهرة', 'العزيزية', 'الموظفين', 'الواديين', 'النسيم', 'الراشدية'],
  },
  {
    name: 'نجران', nameEn: 'Najran', region: 'نجران',
    districts: ['الفيصلية', 'الإسكان', 'العريسة', 'الحضن', 'بدر', 'الفهد'],
  },
  {
    name: 'جازان', nameEn: 'Jazan', region: 'جازان',
    districts: ['الكورنيش', 'الروضة', 'الشاطئ', 'العزيزية', 'النخيل'],
  },
  {
    name: 'الباحة', nameEn: 'Al Bahah', region: 'الباحة',
    districts: ['المركزية', 'الأندلس', 'الحوية', 'العقيق', 'بلجرشي'],
  },
  {
    name: 'سكاكا', nameEn: 'Sakaka', region: 'الجوف',
    districts: ['الفيصلية', 'العزيزية', 'الجامعة', 'الإسكان', 'النزهة'],
  },
  {
    name: 'عرعر', nameEn: 'Arar', region: 'الحدود الشمالية',
    districts: ['البلد', 'الجامعة', 'الخالدية', 'النزهة'],
  },
  {
    name: 'ينبع', nameEn: 'Yanbu', region: 'المدينة المنورة',
    districts: ['ينبع الصناعية', 'ينبع البحر', 'الكورنيش', 'الحارة', 'الفيصلية'],
  },
];

// 🌍 المناطق الإدارية (للفلترة في صفحات أخرى)
export const SAUDI_REGIONS = [
  'الرياض', 'مكة المكرمة', 'المدينة المنورة', 'القصيم', 'الشرقية',
  'عسير', 'تبوك', 'حائل', 'الحدود الشمالية', 'جازان', 'نجران', 'الباحة', 'الجوف',
];

export function getDistrictsForCity(cityName: string): string[] {
  const city = SAUDI_CITIES.find((c) => c.name === cityName);
  return city?.districts ?? [];
}
